module.exports = __webpack_public_path__ + "static/media/threshold-warning.f04c4c81.gif";